module.exports = "/_next/static/images/6d7132f9c535a1a818e3577f7f5ea001-card-and-phone-3d-md@1x.jpg";